export enum EmployementSpecialCase {
Internship,
PrivateAndClosedPublic,
PrivateAndWidePublic,
}
